"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Copyright 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var ItemRange = function () {
    function ItemRange(topCount, renderCount, bottomCount) {
        (0, _classCallCheck3.default)(this, ItemRange);

        this.topCount = topCount;
        this.renderCount = renderCount;
        this.bottomCount = bottomCount;
    }

    (0, _createClass3.default)(ItemRange, [{
        key: "contains",
        value: function contains(range) {
            // don't contain empty ranges
            // as it will prevent clearing the list
            // once it is scrolled far enough out of view
            if (!range.renderCount && this.renderCount) {
                return false;
            }
            return range.topCount >= this.topCount && range.topCount + range.renderCount <= this.topCount + this.renderCount;
        }
    }, {
        key: "expand",
        value: function expand(amount) {
            // don't expand ranges that won't render anything
            if (this.renderCount === 0) {
                return this;
            }

            var topGrow = Math.min(amount, this.topCount);
            var bottomGrow = Math.min(amount, this.bottomCount);
            return new ItemRange(this.topCount - topGrow, this.renderCount + topGrow + bottomGrow, this.bottomCount - bottomGrow);
        }
    }, {
        key: "totalSize",
        value: function totalSize() {
            return this.topCount + this.renderCount + this.bottomCount;
        }
    }]);
    return ItemRange;
}();

var LazyRenderList = function (_React$Component) {
    (0, _inherits3.default)(LazyRenderList, _React$Component);

    function LazyRenderList() {
        (0, _classCallCheck3.default)(this, LazyRenderList);
        return (0, _possibleConstructorReturn3.default)(this, (LazyRenderList.__proto__ || (0, _getPrototypeOf2.default)(LazyRenderList)).apply(this, arguments));
    }

    (0, _createClass3.default)(LazyRenderList, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                itemHeight = _props.itemHeight,
                items = _props.items,
                renderItem = _props.renderItem;
            var renderRange = this.state.renderRange;
            var topCount = renderRange.topCount,
                renderCount = renderRange.renderCount,
                bottomCount = renderRange.bottomCount;


            var paddingTop = topCount * itemHeight;
            var paddingBottom = bottomCount * itemHeight;
            var renderedItems = (items || []).slice(topCount, topCount + renderCount);

            var element = this.props.element || "div";
            var elementProps = {
                "style": { paddingTop: paddingTop + "px", paddingBottom: paddingBottom + "px" },
                "className": this.props.className
            };
            return _react2.default.createElement(element, elementProps, renderedItems.map(renderItem));
        }
    }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(props, state) {
            var range = LazyRenderList.getVisibleRangeFromProps(props);
            var intersectRange = range.expand(props.overflowMargin);
            var renderRange = range.expand(props.overflowItems);
            var listHasChangedSize = !!state && renderRange.totalSize() !== state.renderRange.totalSize();
            // only update render Range if the list has shrunk/grown and we need to adjust padding OR
            // if the new range + overflowMargin isn't contained by the old anymore
            if (listHasChangedSize || !state || !state.renderRange.contains(intersectRange)) {
                return { renderRange: renderRange };
            }
            return null;
        }
    }, {
        key: "getVisibleRangeFromProps",
        value: function getVisibleRangeFromProps(props) {
            var items = props.items,
                itemHeight = props.itemHeight,
                scrollTop = props.scrollTop,
                height = props.height;

            var length = items ? items.length : 0;
            var topCount = Math.min(Math.max(0, Math.floor(scrollTop / itemHeight)), length);
            var itemsAfterTop = length - topCount;
            var visibleItems = height !== 0 ? Math.ceil(height / itemHeight) : 0;
            var renderCount = Math.min(visibleItems, itemsAfterTop);
            var bottomCount = itemsAfterTop - renderCount;
            return new ItemRange(topCount, renderCount, bottomCount);
        }
    }]);
    return LazyRenderList;
}(_react2.default.Component);

exports.default = LazyRenderList;


LazyRenderList.defaultProps = {
    overflowItems: 20,
    overflowMargin: 5
};

LazyRenderList.propTypes = {
    // height in pixels of the component returned by `renderItem`
    itemHeight: _propTypes2.default.number.isRequired,
    // function to turn an element of `items` into a react component
    renderItem: _propTypes2.default.func.isRequired,
    // scrollTop of the viewport (minus the height of any content above this list like other `LazyRenderList`s)
    scrollTop: _propTypes2.default.number.isRequired,
    // the height of the viewport this content is scrolled in
    height: _propTypes2.default.number.isRequired,
    // all items for the list. These should not be react components, see `renderItem`.
    items: _propTypes2.default.array,
    // the amount of items to scroll before causing a rerender,
    // should typically be less than `overflowItems` unless applying
    // margins in the parent component when using multiple LazyRenderList in one viewport.
    // use 0 to only rerender when items will come into view.
    overflowMargin: _propTypes2.default.number,
    // the amount of items to add at the top and bottom to render,
    // so not every scroll of causes a rerender.
    overflowItems: _propTypes2.default.number
};
module.exports = exports["default"];
//# sourceMappingURL=LazyRenderList.js.map